import { EllipsisReduxStore } from '~/types'

const initialState: EllipsisReduxStore['websites'] = {}

export const SET_WEBSITES = 'SET_WEBSITES'

export function setWebsites(data: typeof initialState) {
  return {
    type: SET_WEBSITES,
    payload: data,
  } as const
}

type ActionTypes = ReturnType<typeof setWebsites>

export function reducer(state = initialState, action: ActionTypes) {
  switch (action.type) {
    case SET_WEBSITES:
      return action.payload
    default:
      return state
  }
}
